/// <reference path="./index.d.ts" />
import * as React from 'react';
import doLog from '../../common/log';
import PPE from './ppe';
import SelfCompany from './self-company';
import Verify from './verify';
import Normal from './normal';
import './index.scss';

const {useEffect} = React;

interface propTypes {
  i18n: any;
  productId: string;
  seller: SellerObject;
}

export default function Index(props: propTypes) {
  const { seller, i18n } = props;
  const {
    companyName,
    selfOperatedInfo,
    sellerSelfOperated,
    authCards } = seller;

  useEffect(() => {
    doLog('/sc.details.companyCard', '', 'EXP');
  }, [])
    

  // PPE
  if (selfOperatedInfo) {
    return <PPE {...selfOperatedInfo} i18n={i18n} companyName={companyName} />
  }else
  // 自营
  if (sellerSelfOperated) {
    return <SelfCompany {...props} />
  }else
  // 认证商家
  if (authCards && authCards.value) {
    return <Verify {...props} />
  }

  return <Normal {...props} />
}
